"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCookieToUrl = void 0;
var _logger = require("@ori/logger");
var _presentationUtils = require("@ori/presentation-utils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _constants = require("./constants");
/**
 * Reads cookie and transforms them into url - if found.
 * Mostly used for management of store parameter and pbs_owner cookie.
 */
const useCookieToUrl = parameters => {
  const logger = (0, _logger.useLogger)('useCookieToUrl');
  (0, _react.useEffect)(() => {
    const removeQueryParameter = parameters?.removeQueryParameter ?? _presentationUtils.removeQueryParameter;
    const setQueryParameter = parameters?.setQueryParameter ?? _presentationUtils.ensureQueryParameter;
    let foundPrev = false;
    for (const cookieInfo of _constants.cookiesToTransform) {
      const {
        cookie: cookieName,
        queryParam: queryParamName,
        stopIfFound,
        stopIfFoundPrev,
        removeIfNotFound
      } = cookieInfo;
      const cookieValue = _jsCookie.default.get(cookieName) ?? '';
      const stop = stopIfFoundPrev && foundPrev;
      if (cookieValue.length === 0) {
        if (removeIfNotFound) {
          removeQueryParameter(queryParamName);
        }
        logger.info(`Cookie value under the name of '${cookieName}' was not found!`);
        foundPrev = false;

        // stop if we should stop prematurely
        if (stop) {
          break;
        }
        continue;
      }

      // Ensure that query parameter is present and with correct value
      setQueryParameter(queryParamName, cookieValue);
      foundPrev = true;
      if (stopIfFound ?? stop) {
        break;
      }
    }
  }, [logger, parameters?.removeQueryParameter, parameters?.setQueryParameter]);
};
exports.useCookieToUrl = useCookieToUrl;
